import type { RouteRecordRaw } from 'vue-router';

import { wrapRuntimeImport } from '@/shared/helpers/async.helpers';
import { makePermissionMeta } from '@/shared/helpers/permissions.helpers';

export const AdminSalesRoutes: RouteRecordRaw[] = [
    {
        path: '',
        redirect: '/admin/sales/categories'
    },
    {
        path: 'payments',
        component: wrapRuntimeImport(() => import('./screens/payments.vue')),
        meta: { admin: true },
        redirect: '/admin/sales/payments/payment-methods',
        children: [
            {
                path: 'payment-methods',
                component: wrapRuntimeImport(() => import('./screens/payments/payment-methods-tab.vue')),
                meta: { admin: true }
            },
            {
                path: 'stripe-account',
                component: wrapRuntimeImport(() => import('./screens/payments/stripe-account.vue')),
                meta: { admin: true }
            },
            {
                path: 'card-terminals',
                component: wrapRuntimeImport(() => import('./screens/payments/card-terminals.vue')),
                meta: { admin: true }
            }
        ]
    },
    {
        path: 'payments/stripe-oauth',
        component: wrapRuntimeImport(() => import('./screens/payments/stripe-oauth.vue')),
        meta: { admin: true }
    },
    {
        path: 'quickbooks',
        component: wrapRuntimeImport(() => import('./screens/quickbooks.vue')),
        meta: { admin: true }
    },
    {
        path: 'fulfillment',
        component: wrapRuntimeImport(() => import('./screens/fulfillment.vue')),
        meta: { admin: true, ...makePermissionMeta('sales', 'fulfillmentEdit') }
    },
    {
        path: 'categories',
        component: wrapRuntimeImport(() => import('./screens/categories.vue')),
        meta: { admin: true }
    },
    {
        path: 'bookable-types',
        component: wrapRuntimeImport(() => import('./screens/bookable-types.vue')),
        meta: { admin: true }
    },
    {
        path: 'financial-accounts',
        component: wrapRuntimeImport(() => import('./screens/financial-accounts.vue')),
        meta: { admin: true }
    },
    {
        path: 'predefined-discounts',
        component: wrapRuntimeImport(() => import('./screens/predefined-discounts.vue')),
        meta: { admin: true }
    },
    {
        path: 'credit-pools',
        component: wrapRuntimeImport(() => import('./screens/credit-pools.vue')),
        meta: { admin: true }
    },
    {
        path: 'modifier-sets',
        component: wrapRuntimeImport(() => import('./screens/modifier-sets.vue')),
        meta: { admin: true }
    }
];
